import React from "react";

import styles from "./styles/PrimaryIcon.scss";

const PrimaryIcon = ({ className, handleFavorite, ad, favoriteIds }) => {
  const isFavorite = favoriteIds ? favoriteIds.includes(ad.id) : ad.isFavorite;

  return (
    <span
      role="button"
      tabIndex={0}
      className={`${className} ${styles.favoriteIcon} ${isFavorite ? styles.isFavorite : ""}`}
      onClick={handleFavorite}
      aria-label="Spremljeni oglasi"
    >
      <svg width="22" height="20" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g fillRule="nonzero">
            <polygon
              className={styles.heartFill}
              points="21.5831 12.2779 12.6387 20.5834 11.9998 20.8497 10.0831 19.3056 6.2498 16.1112 3.6942 12.9167 1.7776 10.3612 1.1387 6.5279 3.0553 2.6945 6.2498 1.4167 9.4442 2.0556 11.9998 4.6112 12.6387 3.9723 15.8331 1.4167 19.0276 2.0556 21.5831 3.9723 22.8609 7.8056"
            />
            <path
              fill="#FFF"
              d="M12,21.3802 C11.6726,21.3802 11.3569,21.2608 11.1109,21.0438 C10.1817,20.2258 9.2859,19.4571 8.4956,18.779 L8.4915,18.7755 C6.1744,16.7874 4.1734,15.0705 2.7812,13.3792 C1.2249,11.4884 0.5,9.6957 0.5,7.7372 C0.5,5.8344 1.148,4.079 2.3246,2.794 C3.5152,1.4939 5.1489,0.7778 6.9252,0.7778 C8.2529,0.7778 9.4688,1.2004 10.539,2.0338 C11.0791,2.4545 11.5687,2.9693 12,3.5698 C12.4315,2.9693 12.9209,2.4545 13.4612,2.0338 C14.5314,1.2004 15.7473,0.7778 17.0749,0.7778 C18.8511,0.7778 20.485,1.4939 21.6756,2.794 C22.8521,4.079 23.5,5.8344 23.5,7.7372 C23.5,9.6957 22.7753,11.4884 21.219,13.379 C19.8268,15.0705 17.826,16.7872 15.5092,18.7751 C14.7174,19.4543 13.8202,20.2242 12.889,21.0442 C12.6431,21.2608 12.3273,21.3802 12,21.3802 Z M6.9252,2.1343 C5.5297,2.1343 4.2476,2.6951 3.315,3.7135 C2.3685,4.7472 1.8471,6.1761 1.8471,7.7372 C1.8471,9.3844 2.4552,10.8575 3.8184,12.5136 C5.1361,14.1145 7.096,15.7961 9.3652,17.7432 L9.3694,17.7467 C10.1628,18.4275 11.0621,19.1992 11.9981,20.0232 C12.9397,19.1976 13.8404,18.4246 14.6353,17.7428 C16.9044,15.7957 18.8641,14.1145 20.1817,12.5136 C21.5448,10.8575 22.1529,9.3844 22.1529,7.7372 C22.1529,6.1761 21.6315,4.7472 20.685,3.7135 C19.7525,2.6951 18.4703,2.1343 17.0749,2.1343 C16.0526,2.1343 15.114,2.4615 14.2852,3.1068 C13.5466,3.682 13.0322,4.4092 12.7305,4.918 C12.5754,5.1797 12.3023,5.3359 12,5.3359 C11.6977,5.3359 11.4246,5.1797 11.2695,4.918 C10.968,4.4092 10.4535,3.682 9.7148,3.1068 C8.886,2.4615 7.9474,2.1343 6.9252,2.1343 Z"
            />
          </g>
        </g>
      </svg>
    </span>
  );
};

export default PrimaryIcon;



// WEBPACK FOOTER //
// ./src/containers/FavoriteButtonWhite/PrimaryIcon.tsx